module.exports = __webpack_public_path__ + "img/icon_kaitijieduan.47ac1580.svg";